import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { AuthFormButton } from "src/page-components/auth/AuthFormButton";
import { ConfirmationPopup } from "src/components/ModalWindow/ConfirmationPopup";
import { Button } from "src/components/Button";
import { scrollTop } from "src/utils/scrollTop";
import { PATHNAMES } from "src/constants/routes";
import { ButtonVariants } from "src/components/Button/types";
import { cloneActionButtonsTrns } from "./trns";
import { ConfirmationPopupV2 } from "src/components/ConfirmationPopupV2";

const DEFAULT_BUTTON_CLASSNAME =
  "w-full sm:max-w-37.5 px-10 !py-3.5 font-medium";

export const ActionButtons = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const confirmationPopup = useModal();

  const onConfirm = () => {
    scrollTop();
    navigate(PATHNAMES.HOME);
  };

  return (
    <div className="flex justify-between gap-2 sm:gap-10 sm:justify-end">
      <Button
        type="button"
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={confirmationPopup.openModal}
      >
        {t(cloneActionButtonsTrns.cancelButton)}
      </Button>

      <AuthFormButton className={DEFAULT_BUTTON_CLASSNAME}>
        {t(cloneActionButtonsTrns.publishButton)}
      </AuthFormButton>

      <ConfirmationPopupV2 {...confirmationPopup} onConfirm={onConfirm} />
    </div>
  );
};
